import React, { useState } from 'react';
import Modal from 'react-modal';
import cookies from 'react-cookies';
import { COOKIES, AUTH_COOKIE_DOMAIN } from '../../helpers';
import styles from './v2_migration.module.scss';

const V2_URL = 'https://v2business.sagibonus.com';
const MODAL_FLAG = 'v2_migration_show_modal';
const LANG_KEY = 'v2_migration_lang';

const COPY = {
  ru: {
    bannerText: '1 сентября 2026 мы переехали на новый сайт Sagi. Старая версия больше не развивается.',
    bannerButton: 'Перейти на новый сайт',
    title: 'Мы переехали на новый сайт',
    lead: 'У Sagi появился новый личный кабинет. Мы собрали его с нуля — современный дизайн, понятный интерфейс и куда более мощная аналитика.',
    whatHeading: 'Что это значит:',
    points: [
      { b: 'С 1 сентября 2026', t: ' — мы работаем в новом кабинете. Все новые функции выходят только там.' },
      { b: 'Старый кабинет', t: ' — пока доступен, но больше не обновляется и будет отключён. Переходите в новый.' },
    ],
    note: 'Ваши данные, программа лояльности и все настройки уже перенесены — ничего переносить не нужно.',
    stay: 'Остаться в старом кабинете',
    go: 'Перейти в новый кабинет',
  },
  kz: {
    bannerText: '2026 жылғы 1 қыркүйекте біз Sagi-дің жаңа сайтына көштік. Ескі нұсқа бұдан әрі дамытылмайды.',
    bannerButton: 'Жаңа сайтқа өту',
    title: 'Біз жаңа сайтқа көштік',
    lead: 'Sagi-де жаңа жеке кабинет пайда болды. Оны жаңадан жасадық — заманауи дизайн, түсінікті интерфейс және әлдеқайда қуатты аналитика.',
    whatHeading: 'Бұл нені білдіреді:',
    points: [
      { b: '2026 жылғы 1 қыркүйектен бастап', t: ' — біз жаңа кабинетте жұмыс істейміз. Барлық жаңа мүмкіндіктер тек сонда шығады.' },
      { b: 'Ескі кабинет', t: ' — әзірге қолжетімді, бірақ бұдан әрі жаңартылмайды және өшіріледі. Жаңасына көшіңіз.' },
    ],
    note: 'Деректеріңіз, бонус бағдарламаңыз және барлық баптаулар жаңа кабинетке көшірілді — ештеңе тасымалдаудың қажеті жоқ.',
    stay: 'Ескі кабинетте қалу',
    go: 'Жаңа кабинетке өту',
  },
};

const modalStyles = {
  overlay: { backgroundColor: 'rgba(16, 24, 40, 0.55)', zIndex: 1000 },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 0,
    borderRadius: 28,
    maxWidth: '460px',
    width: '92%',
  },
};

const goToV2 = () => {
  const token = cookies.load(COOKIES.TOKEN);
  if (token) {
    cookies.save(COOKIES.TOKEN, token, { path: '/', domain: AUTH_COOKIE_DOMAIN });
  }
  window.location.assign(V2_URL);
};

const V2Migration = () => {
  const [lang, setLang] = useState(() => (localStorage.getItem(LANG_KEY) === 'kz' ? 'kz' : 'ru'));
  const [modalOpen, setModalOpen] = useState(() => {
    if (localStorage.getItem(MODAL_FLAG) === '1') {
      localStorage.removeItem(MODAL_FLAG);
      return true;
    }
    return false;
  });

  const t = COPY[lang];
  const closeModal = () => setModalOpen(false);
  const switchLang = (next) => {
    setLang(next);
    localStorage.setItem(LANG_KEY, next);
  };

  return (
    <>
      <div className={styles.banner}>
        <span className={styles.bannerText}>{t.bannerText}</span>
        <button type="button" className={styles.bannerButton} onClick={goToV2}>
          {t.bannerButton}
        </button>
      </div>

      <Modal ariaHideApp={false} isOpen={modalOpen} style={modalStyles} onRequestClose={closeModal}>
        <div className={styles.modal}>
          <div className={styles.top}>
            <div className={styles.logo}>Sagi</div>
            <div className={styles.langToggle}>
              <button
                type="button"
                className={lang === 'ru' ? styles.langActive : styles.langBtn}
                onClick={() => switchLang('ru')}
              >
                РУС
              </button>
              <button
                type="button"
                className={lang === 'kz' ? styles.langActive : styles.langBtn}
                onClick={() => switchLang('kz')}
              >
                ҚАЗ
              </button>
            </div>
          </div>

          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.lead}>{t.lead}</p>

          <h4 className={styles.whatHeading}>{t.whatHeading}</h4>
          <ul className={styles.points}>
            {t.points.map((p, i) => (
              <li key={i}>
                <strong>{p.b}</strong>
                {p.t}
              </li>
            ))}
          </ul>

          <p className={styles.note}>{t.note}</p>

          <div className={styles.actions}>
            <button type="button" className={styles.stay} onClick={closeModal}>
              {t.stay}
            </button>
            <button type="button" className={styles.go} onClick={goToV2}>
              {t.go}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default V2Migration;
